import { CommonModule } from '@angular/common';
import { Component, inject, OnInit, ViewChild } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { MessageService } from 'primeng/api';
import { SignalRService } from './shared/services/signalR.service';
import { EfMessageService } from './core/common/toast-outlet/ef-message.service';
import { ProgressStateService } from './shared/services/progressstate.service';
import { JobStatus, JobStatusDetail, JobType } from './shared/models/progress.model';
import { ProgressService } from './shared/services/progress.service';
import { ProgressbarComponent } from './shared/component/progressbar/progressbar.component';
import { ProgressbarCommunicationService } from './shared/services/progressbar-communication.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  imports: [RouterOutlet, CommonModule, ProgressbarComponent],
  providers: [MessageService, SignalRService, EfMessageService]
})
export class AppComponent implements OnInit {
  @ViewChild(ProgressbarComponent) public ProgressbarComponent: ProgressbarComponent | undefined;
  private process: JobStatusDetail[] = [];
  public importexportStatus = JobStatus;
  private readonly translateService: TranslateService = inject(TranslateService);
  constructor(
    private readonly signalRService: SignalRService,
    private readonly progressService: ProgressService,
    private readonly progressStateService: ProgressStateService,
    private readonly progressbarCommunicationService: ProgressbarCommunicationService
  ) {}

  public ngOnInit(): void {
    this.signalRService.jobStatus$.subscribe((message: any) => {
      this.process = this.progressStateService.getProcess();
      if (message && message.progress !== null) {
        this.handleJobStatusMessage(message);
      }
    });

    this.progressbarCommunicationService.progressStatus$.subscribe(({ error, status }) => {
      this.ProgressbarComponent?.openImportStatusDialog(error, status);
    });
  }

  private handleJobStatusMessage(message: any): void {
    this.updateDownloadCustomLimitSet(message);
    this.updateDownloadGroups(message);

    let obj = this.process.find((p) => p.id === message.requestCode);
    if (!obj) {
      obj = this.createJobStatusDetail(message);
      this.process.push(obj);
    }

    if (message.progress > obj.progress) {
      obj.progress = message.progress;
      obj.errorNote = message;
      this.progressService.feedProcess(this.process);
      this.progressStateService.setProcess(this.process);
    }
  }

  private updateDownloadCustomLimitSet(message: any): void {
    const objDownloadCustomLimitSet = this.process.find((p) => p.name === this.translateService.instant('vbeiDownloadLimitSet'));
    if (objDownloadCustomLimitSet && message.jobType === JobType.DownloadCustomLimitSets) {
      objDownloadCustomLimitSet.id = message.requestCode;
    }
  }

  private updateDownloadGroups(message: any): void {
    const objDownloadGroups = this.process.find((p) => p.name === this.translateService.instant('vbeiDownloadGroups'));
    if (objDownloadGroups && message.jobType === JobType.DownloadGroups) {
      objDownloadGroups.id = message.requestCode;
    }
  }

  private createJobStatusDetail(message: any): JobStatusDetail {
    const obj = new JobStatusDetail();
    if (message.jobType === JobType.DownloadCustomLimitSets) {
      obj.name = this.translateService.instant('vbeiDownloadLimitSet');
    } else if (message.jobType === JobType.DownloadGroups) {
      obj.name = this.translateService.instant('vbeiDownloadGroups');
    } else if (message.jobType === JobType.BulkSaveGroups) {
      obj.name = this.translateService.instant('vbeiImportGroups');
    } else {
      obj.name = this.translateService.instant('vbeiImportLimitSets');
    }
    obj.id = message.requestCode;
    obj.status = this.importexportStatus.New;
    return obj;
  }
}
